<template>
  <section class="c-section c-section--complete" :style="`background-image: url(${baseUrl}img/bg-colors.svg)`">

    <main-header></main-header>
      
    <div class="c-section__item">
      <div class="o-container o-container--medium">
        <div class="c-complete-intro">
          <div class="c-complete-intro__column s-entry-content s-entry-content--large">
            <p><em>Your entry has been successfully submitted!</em></p>
            <p>The time has now come. The secret Scroll of Ikigai is now open. From this point on, your life will never be the same again…</p>
          </div>
          <div class="c-complete-intro__column">
            <div class="c-complete-intro__img">
              <img :src="`${baseUrl}img/chest-complete.png`" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="c-section__item">
      <div class="o-container o-container--medium">

        <div class="c-complete-inari">
          <div class="c-inari c-inari--complete">
            <img :src="`${baseUrl}img/inari.svg`" alt="INARI">
          </div>
          <div class="c-complete-inari__bubble">
            <div class="s-entry-content">
              <p>I.N.A.R.I. Yes. I named the passcode after myself, hehe. Sometimes, the answers right in front of you are the hardest to see.</p>

              <p>I now present you, the secret Scroll of Ikigai. Use it wisely and may it serve you well along the journey to discovering your ikigai in Japan.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="c-section__item">
      <div class="o-container o-container--large">
        <div class="c-scroll c-scroll--complete">
          <img class="c-scroll__top" :src="`${baseUrl}img/scroll/top-complete.svg`" alt="">
          <div class="c-scroll__middle">
            <div class="c-complete-scroll">
              
              <header>
                <h2>THE SECRET SCROLL OF IKIGAI</h2>
              </header>
              
              <div class="c-arrow-down"></div>

              <div class="c-complete-scroll__container">
                <div class="c-complete-scroll--section c-complete-scroll__intro">
                  <div class="c-old-man">
                    <img :src="`${baseUrl}img/old-man.svg`" alt="" width="85">
                  </div>
                  <div class="s-entry-content">
                    <p class="lead">Breathe in... and out.</p>

                    <p>Clear your mind of distractions, it’s time to listen to what your heart truly desires and visualise your true passions.</p>

                    <p>On the island of Okinawa, in southern Japan, ikigai is the way of life. The island also has the highest number of centenarians in the world. Some say this is more than coincidence.</p>

                    <p>Are you ready to learn the secret of harnessing your ikigai?</p>
                  </div>
                </div>

                <div class="c-complete-scroll--section c-complete-scroll__what">
                  <div class="s-entry-content">
                    <h3>What is ikigai?</h3>
                    <p>Ikigai is an age-old Japanese concept that means ‘your reason for being’. Your ikigai is what drives you to get up in the morning. It gives you purpose, and with it, can lead to what we keep searching for... longevity and joyful living.</p>
                  </div>
                  <div class="c-bed-rise">
                    <img :src="`${baseUrl}img/bed-rise.svg`" alt="" width="285">
                  </div>
                </div>

                <div class="c-complete-scroll--section c-complete-scroll__flower">
                  <div class="s-entry-content">
                    <h3>Ikigai is a mix of:</h3>
                    <ul class="c-flower-list">
                      <li>Your passion</li>
                      <li>Your purpose</li>
                      <li>Your satisfaction</li>
                      <li>Your fulfillment</li>
                      <li>Your calling</li>
                      <li>Your true self</li>
                      <li>Your values</li>
                      <li>What’s good for society</li>
                    </ul>
                  </div>
                  <div class="c-flower-diagram">
                    <img :src="`${baseUrl}img/flower-diagram.svg`" alt="" width="425">
                  </div>
                </div>

                <div class="c-complete-scroll--section c-complete-scroll__quote">
                  <div class="s-entry-content">
                    <blockquote>
                      <p>A musician must make music, an artist must paint, a poet must write, if he is to be ultimately at peace with himself. What a man can be, he must be</p>
                    </blockquote>
                    <figcaption>Abraham Maslow</figcaption>
                  </div>
                </div>

                <div class="c-complete-scroll--section c-complete-scroll__steps">
                  <h3>The 8 steps of ikigai</h3>
                  
                  <tiny-slider 
                    ref="stepsSlider"
                    :controls="true"
                    :controlsText="['<span>Previous</span>', '<span>Next</span>']"
                    :nav="true"
                    :arrowKeys="true"
                    :mouse-drag="true"
                    :loop="true"
                    items="1"
                    class="c-slider c-slider--steps">
                    <div class="c-slider__slide">
                      <header>
                        <h4>1. Slow down and smell the cherry blossoms</h4>
                        <img :src="`${baseUrl}img/steps/cherry-blossoms.svg`" alt="">
                      </header>
                      <div class="s-entry-content">
                        <p>Modern life moves fast. Slow down and you might just find that what you’re chasing will catch up to you. Take a break from technology and live in the moment. Let your senses enjoy the sights and sounds of your surroundings.</p>

                        <p>Take Action: Clear your mind with a 25 minute walk. Leave your phone at home.</p>
                      </div>
                    </div>
                    <div class="c-slider__slide">
                      <header>
                        <h4>2. Immerse yourself in what fulfills you</h4>
                        <img :src="`${baseUrl}img/steps/singing.svg`" alt="">
                      </header>
                      <div class="s-entry-content">
                        <p>When we focus our energy in the wrong places, we only have time to scratch the surface of life. The greatest experiences come when we dive in with 100% commitment, allowing it to consume us completely. It can take up to ten years to become a sushi chef!</p>

                        <p>Take Action: Spend 10 minutes working on your passion every day for the next 30 days.</p>
                      </div>
                    </div>
                    <div class="c-slider__slide">
                      <header>
                        <h4>3. Find your zen<span>&nbsp;</span></h4>
                        <img :src="`${baseUrl}img/steps/zen-man.svg`" alt="">
                      </header>
                      <div class="s-entry-content">
                        <p>In Japan, we have practiced meditation for over 1500 years. Meditation allows us to focus and control our emotions and outlook on life amidst daily distractions and brings us closer to finding our zen. Silence is full of answers.</p>

                        <p>Take Action: Meditate for 15-30 minutes twice per week.</p>
                      </div>
                    </div>
                    <div class="c-slider__slide">
                      <header>
                        <h4>4. Work to live, don’t live to work</h4>
                        <img :src="`${baseUrl}img/steps/work.svg`" alt="">
                      </header>
                      <div class="s-entry-content">
                        <p>Fulfilling work is healthy for the soul but when life is taken over by work, the soul has no room to grow. It is also important to reflect if your work still aligns with your values and benefits society.</p>

                        <p>Take Action: Is your work taking time away from yourself and the people that matter to you? Make changes if necessary.</p>
                      </div>
                    </div>
                    <div class="c-slider__slide">
                      <header>
                        <h4>5. Prioritise your goals</h4>
                        <img :src="`${baseUrl}img/steps/goals.svg`" alt="">
                      </header>
                      <div class="s-entry-content">
                        <p>In modern life, we are often pulled in many directions at the same time. It’s impossible to please everyone, so you need to prioritise what's most important to you first. If you are not making your own goals, you are probably working on someone else's.</p>

                        <p>Take Action: Write down short term and long term goals and give each one a specific time frame.</p>
                      </div>
                    </div>
                    <div class="c-slider__slide">
                      <header>
                        <h4>6. Try something new</h4>
                        <img :src="`${baseUrl}img/steps/new-drum.svg`" alt="">
                      </header>
                      <div class="s-entry-content">
                        <p>It’s important to preserve our childlike curiosity. This will open up new paths for us. It takes many strokes to paint your life. Keep learning and add new strokes to the canvas. Soon, you’ll be able to see your ikigai within the masterpiece.</p>

                        <p>Take Action: Whether you’re at home or travelling to Japan, look at what activities or classes are available in your area.</p>
                      </div>
                    </div>
                    <div class="c-slider__slide">
                      <header>
                        <h4>7. Take action today</h4>
                        <img :src="`${baseUrl}img/steps/rocket.svg`" alt="">
                      </header>
                      <div class="s-entry-content">
                        <p>Procrastination will steal your time away and take you further away from your goals. Stop talking of tomorrow and start taking steps to finding your ikigai.</p>

                        <p>Take Action: Print out and fill in your own MyikiGuide (below)</p>
                      </div>
                    </div>
                    <div class="c-slider__slide">
                      <header>
                        <h4>8. Just keep going</h4>
                        <img :src="`${baseUrl}img/steps/rock-climbing.svg`" alt="">
                      </header>
                      <div class="s-entry-content">
                        <p>Your journey to discovering your ikigai will require persistence. Most people don’t find their passion straight away, sometimes it takes at least a few tries until you find something which truly fulfills you.</p>

                        <p>Take Action: When you hit a barrier, take a breath, then carry on.</p>
                      </div>
                    </div>
                  </tiny-slider>
                </div>

                <div class="c-complete-scroll--section c-complete-scroll__quote">
                  <div class="s-entry-content">
                    <blockquote class="c-blockquote--fw">
                      <p>What gets you up in the morning (besides your alarm clock)? Mine is deep-fried tofu mmmmm</p>
                    </blockquote>
                    <figcaption>Inari Fox</figcaption>
                  </div>
                </div>

                <div class="c-complete-scroll--section c-complete-scroll__guide">
                  <div class="s-entry-content">
                    <h3>MyikiGuide</h3>
                    <p>Print out the ‘MyikiGuide’ and fill it in to help you determine your true passion.</p>

                    <p><strong>STEPS:</strong></p>
                    
                    <ol>
                      <li>Write down your interests on the left hand column.</li>
                      <li>For each interest, rate how much it applies to each of the 8 elements of ikigai across the other columns out of 10 (10 being very strong).</li>
                      <li>Add up the ratings and write your total on the right hand column.</li>
                      <li>The interest with the highest total may be your true ikigai!</li>
                    </ol>
                  </div>
                </div>

              </div>
                
              <div class="c-arrow-down"></div>
              
              <div class="c-complete-scroll--section c-myikiguide">
                <img class="c-myikiguide__img" :src="`${baseUrl}img/myikiguide.png`" alt="MyIkiGuide">
                <a href="https://www.jnto.org.au/app/uploads/2018/05/Myikiguide.pdf?utm_medium=Website&utm_source=Website&utm_campaign=SecretScrolls&utm_content=Myikiguide" download target="_blank" class="c-button c-button--primary" @click="$ga.event('SecretScrolls', 'Click', 'Download MyIkiguide');">DOWNLOAD MYIKIGUIDE AS PDF</a>
              </div>

              <div class="c-complete-scroll--section c-complete-scroll__passions">
                <h3>Passions</h3>
                <p class="subtitle">Japan is filled with endless passions for you to pursue. Here are three examples:</p>
                
                <tiny-slider 
                  ref="passionsSlider"
                  :controls="true"
                  :controlsText="['<span>Previous</span>', '<span>Next</span>']"
                  :nav="true"
                  :arrowKeys="true"
                  :mouse-drag="true"
                  :loop="true"
                  items="1"
                  class="c-slider c-slider--3col c-slider--passions">
                  <div class="c-slider__slide">
                    <header>
                      <h4>Food</h4>
                      <img :src="`${baseUrl}img/passions/food.svg`" alt="">
                    </header>
                    <div class="s-entry-content">
                      <p>If cooking is your passion, then follow your nose to Kagawa Prefecture on Shikoku Island. It is renowned for producing the country’s best tasting udon noodles with over 800 udon noodle shops to choose from. Here, there are many udon-making classes you can take to learn the full process including dough kneading and udon cutting from local masters.</p>
                    </div>
                  </div>
                  <div class="c-slider__slide c-slider__slide--green">
                    <header>
                      <h4>Martial Arts</h4>
                      <img :src="`${baseUrl}img/passions/martial-arts.svg`" alt="">
                    </header>
                    <div class="s-entry-content">
                      <p>Keeee-yah! If you’re a karate enthusiast, then you have to visit Okinawa - the birthplace of karate. There are approximately 400 dojos (schools) for you to perfect your roundhouse kick. There’s even a famous bar dedicated to karate with rare memorabilia, exhibits and plenty of Japanese whisky!</p>
                    </div>
                  </div>
                  <div class="c-slider__slide c-slider__slide--gold">
                    <header>
                      <h4>Art</h4>
                      <img :src="`${baseUrl}img/passions/art.svg`" alt="">
                    </header>
                    <div class="s-entry-content">
                      <p>For the artistic eye, the Setouchi region has your name written on its canvas. The island of Teshima is home to some of the most beautiful architecture in the world such as the Teshima Art Museum while the island of Naoshima is studded with modern art museums designed by the likes of Tadao Ando, artworks from Monet and Matisse, and iconic outdoor sculptures.</p>
                    </div>
                  </div>
                </tiny-slider>
              </div>

            </div>
          </div>
          <img class="c-scroll__bottom" :src="`${baseUrl}img/scroll/bottom-complete.svg`" alt="">
        </div>
      </div>
    </div>

    <div class="c-section__item">
      <div class="o-container o-container--medium">
        <div class="c-complete-outro">
          <a href="https://www.jnto.org.au/app/uploads/2018/05/Printable-Scroll.pdf?utm_medium=Website&utm_source=Website&utm_campaign=SecretScrolls&utm_content=Scroll" download target="_blank" class="c-button c-button--primary" @click="$ga.event('SecretScrolls', 'Click', 'Download Scroll');">DOWNLOAD SCROLL</a>
        </div>

        <ul class="c-social">
          <li>
            <button class="c-button c-button--alt c-button--facebook" @click="popup('Facebook')">
              <icon class="c-button__icon" name="facebook" role="img" label="Facebook"></icon>
              <span>Share on Facebook</span>
            </button>
          </li>
          <li>
            <button class="c-button c-button--alt c-button--twitter" @click="popup('Twitter')">
              <icon class="c-button__icon" name="twitter" role="img" label="Twitter"></icon>
              <span>Share on Twitter</span>
            </button>
          </li>
          <li>
            <a href="mailto:?subject=Can%20you%20unlock%20the%20Secret%20Scrolls%20of%20Ikigai%3F&amp;body=The%20pursuit%20of%20your%20true%20passion%20can%20lead%20to%20unthinkably%20wonderful%20things.%20What%20are%20they%3F%20That%E2%80%99s%20for%20you%20to%20find%20out.%0A%0AYour%20journey%20to%20all%20the%20answers%20begin%20here.%20Unlock%20the%20secrets%20of%20ikigai%20and%20you%20can%20be%20in%20the%20chance%20to%20win%20return%20flights%20to%20Japan%20for%20you%20and%20your%20friend%20and%20become%20one%20step%20closer%20to%20discovering%20your%20ikigai%20in%20Japan.%0A%0Ahttp%3A%2F%2Fwww.jnto.org.au%2Fsecretscrolls%3Futm_medium%3DEmail%26utm_source%3DWebsite%26utm_campaign%3DSecretScrolls" class="c-button c-button--alt c-button--email" @click="$ga.event('SecretScrolls', 'Click', 'ShareEmail');">
              <icon class="c-button__icon" name="email" role="img" label="Email"></icon>
              <span>Share by Email</span>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="c-complete__footer">
      <img :src="`${baseUrl}img/bg-bottom.svg`" alt="">
    </div>
  </section>
</template>

<script>
  import TinySlider from 'vue-tiny-slider';
  import Icon from '@/components/Icon';
  import MainHeader from '@/components/MainHeader';

  export default {
    name: 'complete',
    components: {
      Icon,
      MainHeader,
      TinySlider,
    },
    data() {
      return {
        isMobile: true,
      };
    },
    methods: {
      checkWindow() {
        if (window.innerWidth < 960) this.isMobile = true;
        else this.isMobile = false;
      },
      onResize() {
        const mobile = this.isMobile;
        this.checkWindow();
        if (this.isMobile === mobile) return;
        if (this.isMobile) {
          this.$refs.stepsSlider.rebuild();
          this.$refs.passionsSlider.rebuild();
        } else {
          this.$refs.stepsSlider.destroy();
          this.$refs.passionsSlider.destroy();
        }
      },
      popup(type) {
        let url;
        switch (type) {
          case 'Facebook':
            url = 'https://www.facebook.com/sharer.php?u=https://www.jnto.org.au/secretscrolls?utm_medium=Facebook&utm_source=Website&utm_campaign=SecretScrolls';
            break;
          case 'Twitter':
            url = 'https://twitter.com/intent/tweet?text=Can you unlock the Secret Scrolls of Ikigai? Find out for your chance to win return flights to Japan for you and your friend.&url=https%3A//www.jnto.org.au/secretscrolls?utm_medium=Twitter%26utm_source=Website%26utm_campaign=SecretScrolls';
            break;
          default:
            url = '';
        }

        this.$ga.event('ResultsPage', 'Click', `Share${type}`);

        const width = 576;
        const height = 256;
        const left = Math.ceil((window.innerWidth - width) / 2)
          + (window.screenLeft || window.screen.left);
        const top = Math.ceil((window.innerHeight - height) / 2)
          + (window.screenTop || window.screen.top);

        const options = `status=1,width=${width},height=${height},left=${left},top=${top}`;
        window.open(url, '_blank', options);
      },
    },
    mounted() {
      this.onResize();
      window.addEventListener('resize', this.onResize);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.onResize);
    },
  };
</script>


// WEBPACK FOOTER //
// Complete.vue?6833f4b5